import React from "react";
import { MdClose, MdInbox, MdMarkEmailRead, MdMarkEmailUnread } from "react-icons/md";
import { elakayAutoText } from "../dataElakay";

// Left Inbox navigation (spec §2-3): a small sub-menu specific to the
// Email Inbox experience -- distinct from the global Elakay User Menu,
// which keeps its own separate "Email Inbox" entry pointing at /email-inbox
// (spec §22). Three real, independently-behaving filters -- Inbox (every
// email), Unread, Read -- narrowed server-side (see emailInboxService.js's
// `filter` param) so counts/results are correct across the WHOLE Inbox,
// not just whatever page happens to be loaded. No separate "All Mail" item:
// this Inbox has no archive/label concept, so it would show the exact same
// set as "Inbox" -- a second nav item with identical behavior would read as
// a fake control, not a real one.
const NAV_ITEMS = [
  { key: "all", icon: MdInbox, get label() { return elakayAutoText("h_emk_inbox_nav_inbox", "Inbox"); } },
  { key: "unread", icon: MdMarkEmailUnread, get label() { return elakayAutoText("h_emk_inbox_nav_unread", "Unread"); } },
  { key: "read", icon: MdMarkEmailRead, get label() { return elakayAutoText("h_emk_inbox_nav_read", "Read"); } },
];

const EmailInboxSidebar = ({ activeFilter, onSelectFilter, unreadCount, readCount, isOpen, onClose }) => {
  const counts = { all: unreadCount + readCount, unread: unreadCount, read: readCount };

  return (
    <>
      <div className={`email-inbox-sidebar-backdrop ${isOpen ? "is-open" : ""}`} onClick={onClose} aria-hidden="true" />
      <nav className={`email-inbox-sidebar ${isOpen ? "is-open" : ""}`} aria-label={elakayAutoText("h_emk_inbox_sidebar_label", "Inbox navigation")}>
        <div className="email-inbox-sidebar-title">
          {elakayAutoText("h_emk_inbox_sidebar_title", "Email")}
          <button
            type="button"
            className="email-inbox-sidebar-close"
            onClick={onClose}
            aria-label={elakayAutoText("h_5ab4ec640d654d", "Fermer")}
          >
            <MdClose />
          </button>
        </div>
        <ul className="email-inbox-nav">
          {NAV_ITEMS.map(({ key, icon: Icon, label }) => (
            <li key={key}>
              <button
                type="button"
                className={`email-inbox-nav-item ${activeFilter === key ? "is-active" : ""}`}
                aria-current={activeFilter === key ? "page" : undefined}
                onClick={() => onSelectFilter(key)}
              >
                <Icon />
                <span className="email-inbox-nav-label">{label}</span>
                <span className="email-inbox-nav-count">{counts[key].toLocaleString()}</span>
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </>
  );
};

export default EmailInboxSidebar;
